import React, { useMemo } from 'react';
import snakeCase from 'lodash-es/snakeCase';
import { useSelector } from 'react-redux';

import { Field } from 'redux-form';
import { FormTooltip } from 'app/components/FormTooltip';
import { TagManagerService } from 'app/services/tagManager.service';
import { SelectBoxGroup } from 'app/components/Controls';
import { getOffersFilteredByGroup } from 'app/store/data/quotationResult';
import {
  SelectBoxGroupItemValue,
  SelectBoxOptions,
} from 'app/components/Controls/SelectBoxGroup/SelectBoxGroup.interface';

import {
  FilterSectionFieldProps,
  SectionFiltersName,
} from '../MoreResultsFilters.interfaces';
import { moreFiltersGTMOptions } from '../moreFiltersGTMOptions';
import { useStyles } from './FilterField.styles';

export default function FilterField({
  section,
  titleSection,
}: {
  section: FilterSectionFieldProps;
  titleSection: SectionFiltersName;
}) {
  const classes = useStyles();

  const offersFilteredSelector = useMemo(
    () => getOffersFilteredByGroup(section.name),
    [section.name]
  );
  const offersFiltered = useSelector(offersFilteredSelector);

  const isOptionDisabled = (option: SelectBoxGroupItemValue): boolean =>
    !offersFiltered.some(
      (offer) =>
        offer.carInsuranceOfferViewFilterDto[titleSection]?.[section.name] ===
        option
    );

  const numberOfOffersWithOption = (option: SelectBoxGroupItemValue): number =>
    offersFiltered.filter(
      (offer) =>
        offer.carInsuranceOfferViewFilterDto[titleSection]?.[section.name] ===
        option
    ).length;

  const sendGTMEvent = (option: SelectBoxOptions, checked: boolean) => {
    const filterName = moreFiltersGTMOptions.get(section.name);
    const eventName = checked ? 'filter_check' : 'filter_uncheck';

    TagManagerService.addDataLayer({
      event: eventName,
      filter_name: filterName,
      filter_value: snakeCase(option.title),
    });
  };

  return (
    <div className={classes.section} key={section.sectionTitle}>
      <Field
        name={section.name}
        component={SelectBoxGroup}
        label={
          <div className={classes.sectionTitle}>
            <div>{section.sectionTitle}</div>
            {section.tooltip && (
              <FormTooltip
                content={section.tooltip}
                className={classes.tooltip}
              />
            )}
          </div>
        }
        props={{
          options: section.options,
          columnDirection: true,
          isOptionDisabled: isOptionDisabled,
          sendGTMEvent: sendGTMEvent,
          numberOffers: numberOfOffersWithOption,
        }}
      />
    </div>
  );
}
